import API from "./axios";

export class SizesService {
    constructor() {

    }
    productsizes(brandId:any): Promise<any> {
        return API.post(`api/index.php`, {"action":"getProductSize","src":"dashboard","retrievalmode":"mysql" , "brandId":brandId});
    }

    
    createSize( data: any): Promise<any> {
      
        return API.post(`api/index.php`, { 'action': 'SizeDataAction', 'src': 'dashboard', retrievalmode: 'mysql',  'data': [data] });
    }
}